<div id="container-home-page">
  <div
    class="row justify-content-center align-items-center px-5 pt-5 pb-0 home-page-light-blue-bg-color">
    <div class="col-6 text-center text-black mt-4">
      <h2 class="fw-bold font-size-40">
        Enhance Resident Insights with Al-Powered Precision
      </h2>
      <p class="my-4 font-size-16">
        Effortlessly streamline resident data collection and creation using
        Minerva, our one-of-a-kind Al-based platform.
      </p>
      <a
        class="btn btn-lg schedule-demo-button px-5 text-white mt-3 mb-4"
        href="https://get.tsolife.com/contact-us"
        target="_blank"
        >Get Started</a
      >
    </div>
    <div class="col-7">
      <img
        class="card-img img-fluid"
        src="assets/images/resident-insights-page/resident-insights-hero.png"
        alt="Resident Insights Hero" />
    </div>
  </div>

  <div class="row justify-content-center bg-white mt-0">
    <div class="col-6 text-center text-black mt-5">
      <h2>Optimizing Resident Data for Enhanced Insights</h2>
      <p class="mt-4 font-size-17">
        Facilitating data creation through embedded analytics, our platform
        empowers teams to harness person-centered data via digitized resident
        profiles, Al-driven actionable insights, and marketing and
        corporate-level analytics.
      </p>
    </div>
  </div>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Effortlessly Generate Digital Resident Profiles
          </h2>
          <p class="card-text img-info-body">
            Leveraging Al capabilities, our platform allows users to conduct
            resident interviews via audio recordings, capturing 650% more data
            than traditional methods.
            <br />
            <br />
            Through advanced data mining and transcription, our platform
            seamlessly transforms these interviews into digital resident
            profiles, offering comprehensive insights into each individual and
            saving staff significant amounts of time by eliminating the need for
            manual data entry.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/resident-insights-page/digital-resident-profile.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/resident-insights-page/personalized-friend-matching.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-center">
        <div class="card-body">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Reduce Isolation With Personalized Friend Matching
          </h2>
          <p class="card-text img-info-body">
            Facilitate meaningful connections with our proprietary friend
            matching algorithm.
            <br />
            <br />
            Analyzing each resident's digital profile, our platform identifies
            potential friendships within communities and enables staff to
            introduce prospects and current residents to new friends and
            coordinate like-minded groups, reducing social isolation and churn.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Cultivate Meaningful Bonds With Intelligent Insights
          </h2>
          <p class="card-text img-info-body">
            Harnessing resident data, our intelligent platform automatically
            generates and delivers timely, relevant actionable insights directly
            to staff members.
            <br />
            <br />
            From birthday reminders to suggested learning resources, our
            intuitive platform identifies activities with the most significant
            impact on a resident's quality of life, enabling staff members to
            establish deeper, more meaningful connections with residents.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/resident-insights-page/cultivate-meaningful-bonds.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/resident-insights-page/unlock-analytics.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-center">
        <div class="card-body">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Unlock Analytics for Strategic Decision-Making
          </h2>
          <p class="card-text img-info-body">
            Access comprehensive insights through our platform's detailed
            analytics dashboards.
            <br />
            <br />
            From demographics crucial for business development to engagement
            touchpoints informing strategic decisions, our analytics empower
            teams to enhance the resident experience and drive success in
            community management.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center p-5 text-white schedule-demo-bg-color">
    <div class="col-5 my-4">
      <h2 class="text-center">Ready to get started ?</h2>
      <p class="text-center mt-4 font-size-20">
        Get a firsthand look at how our platform is enabling operators to
        deliver exceptional resident experiences and thrive in an ever-evolving
        industry landscape.
      </p>
      <div class="d-flex justify-content-center mt-4">
        <a
          class="btn btn-lg btn-outline-light mx-auto"
          href="https://calendly.com/tsolife-david-sawyer/60min"
          target="_blank">
          Schedule Demo
        </a>
      </div>
    </div>
  </div>
</div>
